export const queryKeys = {
  all: ['geolocation'],
};
